'use strict';

(function($) {
    $(function() {

        if ($(window).width() >= 768) {

            $('.gallery-slider--klip').slick({
                dots: false,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                nextArrow: '.arrow-container--klip .arrow--right',
                prevArrow: '.arrow-container--klip .arrow--left'
            });

            $('.gallery-slider--riport').slick({
                dots: false,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                nextArrow: '.arrow-container--riport .arrow--right',
                prevArrow: '.arrow-container--riport .arrow--left'
            });

        }

        $('.kiadvany-slider').slick({
            dots: true,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: '.kiadvany-slider-container .arrow--right',
            prevArrow: '.kiadvany-slider-container .arrow--left'
        });

        $('.tamogato-slider').slick({
            dots: false,
            arrows: false,
            infinite: false,
            slidesToShow: 7,
            slidesToScroll: 7
        });

        $(window).resize(function() {

            if ($(window).width() < 769) {
                $('.gallery-slider--klip').slick('unslick');
                $('.gallery-slider--riport').slick('unslick');
            } else {
                $('.gallery-slider--klip').slick('reinit');
                $('.gallery-slider--riport').slick('reinit');
            }
        });

    });
})(jQuery);
